import axios from 'axios';

import {
    cartRequest,
    cartSuccess,
    cartFail,
    addToCart,
    removeFromCart,
    clearCart,
    clearError,
} from '../slices/cartSlice'

export const getCartItems = (items) => async (dispatch) => {
    try {
        dispatch(cartRequest());

        const { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/v1/products/cart-details`,
            { cartItems: items }
        );

        dispatch(cartSuccess(data));
    } catch (error) {
        const message = error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(cartFail(message));
    }
};

